import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConnectionAppListingComponent } from './connection/connection-app-listing/connection-app-listing.component';
import { ConnectionExplorerComponent } from './connection/connection-explorer/connection-explorer.component';
import { ConnectionListingComponent } from './connection/connection-listing/connection-listing.component';
import { NewConnectionComponent } from './connection/new-connection/new-connection.component';
import { ObjectExplorerComponent } from 'src/app/shared/object-explorer/object-explorer.component';

const routes: Routes = [
  {
    path: '',
    component: ConnectionListingComponent,
    data: { title: 'Connections  - AppiWorks', description: 'Explore your Connections' }

  },
  {
    path: 'apps',
    component: ConnectionAppListingComponent,
  },
  {
    path: 'newconnection',
    component: NewConnectionComponent,
  },
  {
    path: 'connectionexplorer',
    component: ConnectionExplorerComponent,
    data: { title: 'Connection Explorer  - AppiWorks', description: 'Explore your Connection' }
  },
  {
    path: 'connectionexplorer/:objectid',
    component: ObjectExplorerComponent,
    data: { title: 'Connection Explorer  - AppiWorks', description: 'Explore your Connection' }
  },
  // {
  //   path: 'bloom',
  //   component: BloomComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganizationRoutingModule { }
